"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const settlementQuery_1 = require("../../../../queries/settlementQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const walletQuery_1 = require("../../../../queries/walletQuery");
const walletDetails_1 = require("../component/walletDetails");
const SettlementsTable = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../settlementsTable'))));
const ViewReceiptAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../asides/ViewReceiptAside'))));
const SettlementsContent = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { virtualCardId, taskId } = (0, react_router_1.useParams)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const query = virtualCardId ? (0, walletQuery_1.virtualCardTask)(virtualCardId) : (0, walletQuery_1.walletDetailsQuery)(taskId || '');
    const { data: walletData } = (0, react_query_1.useQuery)(query);
    const isCardOwner = walletData?.context?.request?.requester?.userId === userData?.userId;
    const { data: virtualCard } = (0, react_query_1.useQuery)((0, paymentQuery_1.virtualCardDataQuery)(walletData?.subjectId, isCardOwner));
    const { data: settlements } = (0, react_query_1.useQuery)((0, settlementQuery_1.walletSettlementListQuery)({
        virtualCardId: initialData.isCardOwner ? virtualCard?.['info']?.id : virtualCard?.['id'] || '',
    }));
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId || '', { cardprovider: 'tsgo-cardprovider' }));
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(walletDetails_1.TypographySettlement, { "data-testid": "settlement-content", component: "div", children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyTitle, { component: "h3", children: isAmexCardProvider ? strings_1.walletStrings.SETTLEMENT_TITLE_TEXT : strings_1.walletStrings.TRANSACTIONS_TITLE_TEXT }), (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyText, { children: isAmexCardProvider ? strings_1.walletStrings.SETTLEMENT_INFO_TEXT : strings_1.walletStrings.TRANSACTION_INFO_TEXT })] }), settlements?.length === 0 ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", variant: "standard", sx: { marginBottom: '10px' }, children: isAmexCardProvider ? strings_1.walletStrings.NO_SETTLEMENT_TEXT : strings_1.walletStrings.NO_TRANSACTIONS_TEXT })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SettlementsTable, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? null : (0, jsx_runtime_1.jsx)(ViewReceiptAside, {}) })] }))] }));
};
exports.default = SettlementsContent;
